// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4b2b148f","455":"df71d6f0","977":"f7555bd1"}[chunkId] + ".chunk.js";
};